// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard__257Er","sideHidden":"Dashboard_sideHidden__g1lgB","secNav":"Dashboard_secNav__IJXwq","paddingLeft":"Dashboard_paddingLeft__It18t"};